import { LIGHT } from '@miotech/picasso';

const theme = {
  brand: LIGHT.brand,
  primary: LIGHT.primary,
  secondary: LIGHT.secondary,
  third: LIGHT.third,
  fourth: LIGHT.fourth,
  fifth: LIGHT.fifth,
  base: LIGHT.base,
  background: LIGHT.background,
  white: LIGHT.white,
  sky: LIGHT.sky,

  colors: LIGHT.prismList,
};

export default theme;
